import { render, staticRenderFns } from "./TokenTx.vue?vue&type=template&id=84871b3c&"
import script from "./TokenTx.vue?vue&type=script&lang=js&"
export * from "./TokenTx.vue?vue&type=script&lang=js&"
import style0 from "./TokenTx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports